import React from 'react';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-4xl mx-auto px-6 py-4 flex flex-col items-center sm:items-start">
        <div className="text-2xl font-bold tracking-tight">
          <span className="text-brand-gray">digital</span>
          <span className="text-brand-cyan">Track</span>
        </div>
        <span className="text-xs text-brand-gray font-medium uppercase tracking-widest mt-0.5">
          Digital Marketing
        </span>
      </div>
    </header>
  );
};

export default Header;